import { comparisonRows } from '@/mocks/homeData';

export default function ComparisonSection() {
  return (
    <section id="karsilastirma" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Excel, WhatsApp ve defter yerine neden CiftlikWeb?
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            Manuel takip ile dijital sistem arasındaki farkı görün.
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden shadow-sm">
          <div className="grid grid-cols-12 bg-primary-500 px-5 py-3.5">
            <div className="col-span-4">
              <span className="text-background-50 text-sm font-semibold">İşlem</span>
            </div>
            <div className="col-span-4 border-l border-primary-400 pl-4">
              <span className="text-background-50/80 text-sm font-medium">Manuel Takip</span>
            </div>
            <div className="col-span-4 border-l border-primary-400 pl-4">
              <span className="text-background-50 text-sm font-semibold">CiftlikWeb</span>
            </div>
          </div>

          <div className="divide-y divide-background-100">
            {comparisonRows.map((row, i) => (
              <div
                key={i}
                className={`grid grid-cols-12 px-5 py-4 items-center ${
                  i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                }`}
              >
                <div className="col-span-4">
                  <span className="text-sm font-medium text-foreground-800">{row.label}</span>
                </div>
                <div className="col-span-4 pl-4">
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                      <i className="ri-close-circle-line text-foreground-400 text-sm"></i>
                    </div>
                    <span className="text-xs text-foreground-500 leading-relaxed">{row.manual}</span>
                  </div>
                </div>
                <div className="col-span-4 pl-4">
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                      <i className="ri-checkbox-circle-line text-primary-500 text-sm"></i>
                    </div>
                    <span className="text-xs text-foreground-700 leading-relaxed">{row.ciftlikweb}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <a
            href="#demo"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Demo Talep Et
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}